<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
        <div class="col-xl-12">
          <div class="card bg-primary">
            <div class="card-body">
              <p>&nbsp;</p>
              <div class="media faq-widgets">
                <div class="media-body">
                  <h2>{{this.currentLanguage ==='en'?"About us":"เกี่ยวกับเรา"}}</h2>
                  <h5 style="txt">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ภาพวิ่งไม่ควรหาย ความทรงจำไม่ควรหล่น </h5>
                  <p>{{ fbName }} คือแพลตฟอร์มภาพถ่ายงานวิ่งที่พร้อมดูแลทุกช่วงจังหวะของคุณ
                    ด้วยเทคโนโลยีค้นหาใบหน้า (Face Recognition) ที่ช่วยให้คุณตามหารอยยิ้มได้ง่ายๆ เพียงเสี่ยววินาที
                    พร้อมบริการจากทีมช่างภาพมืออาชีพ, <a href="https://runrace.in.th/" target="_blank" style="color: black;text-decoration: underline;font-weight: bold;">ระบบรับสมัครงานวิ่ง</a> และทีมที่ปรึกษาสำหรับผู้จัดงานทั่วประเทศ<br>
                    </p>
                    <p>Easy To Find, Easy To Get<br>
                    We will make perfect shooting for runners,,,
                  </p>
                </div>
                <vue-feather type="award"></vue-feather>
              </div>
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
        <div class="col-xl-12">
          <div class="card" style="background-color: #d2f0fa">
            <div class="card-body" >
              <p>&nbsp;</p>
              <div class="media faq-widgets">
                <div class="media-body" >
                  <h2>{{this.currentLanguage ==='en'?"Contact us":"ติดต่อเรา"}}</h2>
                  <p>Facebook: <a :href="fbUrl" target="_blank">{{fbName}}</a><br>
                      Line Official: <a target="_blank" :href="lineOaUrl">{{lineOaAdd}}</a><br>
                      Email: {{email}} </p>
                      <p>&nbsp;</p>
                </div>
                <vue-feather type="mail"></vue-feather>
              </div>
            </div>
          </div>
        </div>

         <p>&nbsp;</p>
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="media faq-widgets">
                <img
                  style="align-items: center; width: 440px"
                  src="../../assets/images/logo/logo.png"
                />
              </div>
            </div>
          </div>
        </div>
         <p>&nbsp;</p>
      </div>
    </div>
  </div>
</template>
<script>

import {computed, reactive } from 'vue'
import { useHead } from '@vueuse/head'

export default {

  setup() {
    useHead({
      title: computed(() => `เกี่ยวกับเรา ระบบจำหน่ายรูปภาพงานวิ่ง, บริการ ค้นหารอยยิ้มด้วยใบหน้า`),
      meta: [
        {
          name: `description`,
          content: computed(() => `ร่วมพัฒนาไปด้วยกัน #พัฒนาคน #พัฒนางาน #พัฒนาระบบ สู่มาตรฐานเดียวกัน ค้นหารูปวิ่งสุดประทับใจด้วยใบหน้า ด้วยใบหน้า ค้นง่าย จ่ายสะดวก โหลดรูปต้นฉบับ ความละเอียดสูงได้ทันที`),
        },
        {
          name: `keywords`,
          content: computed(() => `เกี่ยวกับเรา,ค้นหารูปวิ่ง, หารูปวิ่ง,งานวิ่ง,running,runninghub,facesearch`),
        }
        ],
     
    })
  },
  data() {
    return {
      currentLanguage: 'th',
      fbName: process.env.VUE_APP_SYSTEM_FACEBOOK_NAME,
      fbUrl: process.env.VUE_APP_SYSTEM_FACEBOOK_URL,
      lineOaAdd: process.env.VUE_APP_SYSTEM_LINE_OA_ADD,
      lineOaUrl: process.env.VUE_APP_SYSTEM_LINE_OA_URL,
      email: process.env.VUE_APP_SYSTEM_EMAIL,
    };
  },
  async created(){
    this.currentLanguage = localStorage.getItem('currentLanguage');
  },


};
</script>